export default from './categories-page-header';



// WEBPACK FOOTER //
// ./app/containers/categories-page-header/index.js